import { useQueryClient } from '@tanstack/react-query';
import { type FormEvent, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router';
import { Field, LogoContent } from '@reikraft/ui';
import { api, ApiError } from '../api';

export function LoginPage() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const qc = useQueryClient();

  const submit = async (e: FormEvent) => {
    e.preventDefault();
    setBusy(true);
    setError(null);
    try {
      await api.post('/admin/auth/login', { email, password });
      qc.clear();
      const next = params.get('next');
      void navigate(next && next.startsWith('/') && !next.startsWith('//') ? next : '/orders', { replace: true });
    } catch (err) {
      setError(err instanceof ApiError ? err.message : 'Не удалось войти');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="adm-login">
      <form onSubmit={submit} noValidate>
        <div className="rk-panel__head">
          <span className="rk-logo rk-logo--compact">
            <LogoContent compact />
          </span>
          <span className="adm-badge">ADMIN</span>
        </div>
        <div className="rk-panel__body rk-stack">
          <h1 className="rk-h1" style={{ fontSize: 20 }}>
            Вход для сотрудников
          </h1>
          <Field label="E-mail">
            <input
              className="rk-input rk-input--lg"
              type="email"
              autoComplete="username"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </Field>
          <Field label="Пароль" error={error}>
            <input
              className="rk-input rk-input--lg"
              type="password"
              autoComplete="current-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              aria-invalid={!!error}
              required
            />
          </Field>
          <button type="submit" className="rk-btn rk-btn--primary rk-btn--lg rk-btn--block" disabled={busy || !email || !password}>
            {busy ? 'Входим…' : 'Войти'}
          </button>
        </div>
      </form>
    </div>
  );
}
